module.exports = __webpack_public_path__ + "media/39_Long.d16992d0.mp3";